const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoCredicoop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#615c50"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3031",
    points: "3.01 12.72 3.01 13.96 3.01 13.96 4.72 13.96 4.72 12.72 3.01 12.72",
    style: {
      fill: "#ed1c24",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3033",
    points: "6.44 12.72 6.44 13.96 6.44 13.96 4.72 13.96 4.72 12.72 6.44 12.72",
    style: {
      fill: "#f58220",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3035",
    points: "6.44 12.72 6.44 13.96 6.44 13.96 8.15 13.96 8.15 12.72 6.44 12.72",
    style: {
      fill: "#ffcb05",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3037",
    points: "9.87 12.72 9.87 13.96 9.87 13.96 8.15 13.96 8.15 12.72 9.87 12.72",
    style: {
      fill: "#00a651",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3039",
    points: "9.87 12.72 9.87 13.96 9.87 13.96 11.58 13.96 11.58 12.72 9.87 12.72",
    style: {
      fill: "#00aeef",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3041",
    points: "13.3 12.72 13.3 13.96 13.3 13.96 11.58 13.96 11.58 12.72 13.3 12.72",
    style: {
      fill: "#9e76b4",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3043",
    points: "13.3 12.72 13.3 13.96 13.3 13.96 15.01 13.96 15.01 12.72 13.3 12.72",
    style: {
      fill: "#a54686",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3025",
    d: "M11.84,3.99v2.02h-.98v-.11c0-.49-.12-.84-.36-1.07-.24-.23-.62-.34-1.15-.34-.76,0-1.35.26-1.77.79-.42.53-.62,1.27-.62,2.24s.21,1.71.64,2.25c.43.54,1.02.82,1.76.82.54,0,.92-.12,1.16-.37.24-.25.35-.66.35-1.23h.96v2.14c-.45.14-.9.24-1.35.31-.45.07-.9.1-1.36.1-1.27,0-2.25-.35-2.93-1.04-.68-.69-1.01-1.69-1.01-2.99s.36-2.23,1.07-2.92c.71-.7,1.71-1.04,2.99-1.04.37,0,.78.04,1.21.11.43.07.89.19,1.39.34h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoCredicoop);
export default __webpack_public_path__ + "static/media/banco-credicoop.ece786f09b8493af92b37cfa38129f2b.svg";
export { ForwardRef as ReactComponent };